import type { IconSvgObject } from './types';

const DeliveryBox02Icon: IconSvgObject = [
  ["path", { d: "M2.5 19.5V6.5H21.5V19.5C21.5 20.6046 20.6046 21.5 19.5 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4.9 3.3L2.5 6.5H21.5L19.1 3.3C18.7223 2.79639 18.1295 2.5 17.5 2.5H6.5C5.87049 2.5 5.27771 2.79639 4.9 3.3Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6 18H11M6 15H9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default DeliveryBox02Icon;
